function replace(url) {
	if ( ! url ) {
		return '';
	}
	// TODO: update
	return url.replace('amprog-devprogress.vipdev.lndo.site', 'stage-amprog.devprogress.org');
}
export default replace;